import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WelcomeCardDialogData {
  currentFilters: any;
}

@Component({
    selector: 'app-welcome-card-dialog',
    templateUrl: './welcome-card-dialog.component.html',
    styleUrls: ['./welcome-card-dialog.component.css'],
    standalone: false
})
export class WelcomeCardDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<WelcomeCardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WelcomeCardDialogData
  ) {}

  get currentFilterKeys(): string[] {
    const filters = this.data?.currentFilters || {};
    return Object.keys(filters);
  }

  generateWithCurrentFilter() {
    this.dialogRef.close({
      action: 'currentFilter',
      filters: this.data.currentFilters
    });
  }

  displayFilterValue(entry: any): string {
    if (entry == null) {
      return '';
    }
    if (typeof entry === 'object' && 'value' in entry) {
      const valueStr = this.formatValue((entry as any).value);
      const mode = (entry as any).matchMode ? ` [${(entry as any).matchMode}]` : '';
      return `${valueStr}${mode}`.trim();
    }
    return this.formatValue(entry);
  }

  private formatValue(value: any): string {
    if (value == null) {
      return '';
    }
    if (Array.isArray(value)) {
      return value.map(v => this.formatValue(v)).filter(v => v !== '').join(', ');
    }
    if (value instanceof Date) {
      return value.toLocaleDateString();
    }
    if (typeof value === 'object') {
      const candidate = (value as any).label || (value as any).name || (value as any).title || (value as any).code || (value as any).id;
      if (candidate != null) {
        return String(candidate);
      }
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }
    return String(value);
  }

  cancel() {
    this.dialogRef.close();
  }
}
